module.exports = __webpack_public_path__ + "img/jätepiste_original.ae752246.jpg";